/*global angular */
import { findIndex } from 'lodash';
import './style.less';

export default function($log, $timeout, $state, $stateParams, Upload, ProfileClass, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const courseId = $stateParams.courseId;
  vm.resultsQueried = false;

  vm.reviewOnly = false;

  vm.addModule = function(suppressBtn) {
    if (!suppressBtn) vm.addBtn = true;
    return ApiClass.coursesIdTypePut({ id: courseId, type: 'modules' }, {}, { queryParams: { manage: true } })
      .then(moduleResponse => {
        const module = moduleResponse.data.module;
        if (!vm.course.modules) vm.course.modules = [];
        vm.course.modules.push(module.module_id);
        vm.modules.arr.push(module);
        vm.modules.obj[module.module_id] = module;
        vm.addBtn = false;
      })
      .catch(error => {
        vm.addBtn = false;
        $log.error(error);
        throw error;
      });
  };

  vm.moveModule = function(dir, index) {
    const temp = vm.course.modules[index];
    if (dir === 'up') {
      vm.course.modules[index] = vm.course.modules[index - 1];
      vm.course.modules[index - 1] = temp;
      vm.activeTab = index - 1;
    } else {
      vm.course.modules[index] = vm.course.modules[index + 1];
      vm.course.modules[index + 1] = temp;
      vm.activeTab = index + 1;
    }
  };

  vm.removeModule = function(moduleId, index) {
    vm.removeBtn = true;
    // TODO: Clean up when moduels is flattened
    return ApiClass.coursesIdTypeTypeIdDelete(
      { id: courseId, type: 'modules', type_id: moduleId },
      {},
      { queryParams: { manage: true } }
    )
      .then(() => {
        vm.removeBtn = false;
        vm.course.modules.splice(index, 1);
        const foundIndex = findIndex(vm.modules.arr, { module_id: moduleId });
        vm.modules.arr.splice(foundIndex, 1);
      })
      .catch(error => {
        vm.removeBtn = false;
        $log.error(error);
        throw error;
      });
  };

  vm.uploadedVideo = function(link, module_id) {
    if (link) {
      return ApiClass.coursesIdTypeTypeIdPatch(
        { id: vm.course.course_id, type: 'modules', type_id: module_id },
        { module: { video: link, video_status: 'Uploaded' } },
        { queryParams: { manage: true } }
      ).then(() => {
        vm.modules.obj[module_id].video = link;
        vm.modules.obj[module_id].video_status = 'Uploaded';
        vm.pdfBtn = false;
      });
    }
    return ApiClass.coursesIdTypeTypeIdPatch(
      { id: vm.course.course_id, type: 'modules', type_id: module_id },
      { module: { video: link, video_status: 'Error - Retry' } },
      { queryParams: { manage: true } }
    ).then(() => {
      vm.modules.obj[module_id].videoStatus = 'Error - Retry';
      vm.pdfBtn = false;
    });
  };

  vm.uploadedPdf = function(link, module_id) {
    if (link) {
      return ApiClass.coursesIdTypeTypeIdPatch(
        { id: vm.course.course_id, type: 'modules', type_id: module_id },
        { module: { pdf: link, pdf_status: 'Uploaded' } },
        { queryParams: { manage: true } }
      ).then(() => {
        vm.modules.obj[module_id].pdf = link;
        vm.modules.obj[module_id].pdf_status = 'Uploaded';
        vm.pdfBtn = false;
      });
    }
    return ApiClass.coursesIdTypeTypeIdPatch(
      { id: vm.course.course_id, type: 'modules', type_id: module_id },
      { module: { pdf: link, pdf_status: 'Error - Retry' } },
      { queryParams: { manage: true } }
    ).then(() => {
      vm.modules.obj[module_id].pdfStatus = 'Error - Retry';
      vm.pdfBtn = false;
    });
  };

  function activate() {
    try {
      vm.course = vm.ngModel;
      vm.loaded = false;
      vm.error = {};

      if ($state.current.name === 'app.author.courses.course.edit' && vm.ngModel.adminReview) {
        $timeout(() => angular.element('.note-editable').attr('contenteditable', false), 0);
        vm.reviewOnly = true;
      }

      return (vm.loaded = true);
    } catch (error) {
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
      $log.error(error);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/author/modules/controller.js